import useSWR from "swr";
import { Api } from "domain/core";
import { Paged, RequiredSwrResponse, RestQueryExtras } from "domain/models";
import { Indicator, IndicatorSource } from "domain/models/data.models";
import { toPaginationQuery } from "domain/utils";

export const useAdminIndicators = (params: RestQueryExtras): RequiredSwrResponse<Paged<Indicator>, any> => {
  const { data, isValidating, error, mutate, revalidate } = useSWR(`${Api.baseUrl}${Api.admin.indicators.base}${toPaginationQuery(params)}`);
  return { data, isValidating, error, mutate, revalidate };
};

export const useAdminIndicator = (code: string): RequiredSwrResponse<Indicator, any> => {
  const { data, isValidating, error, mutate, revalidate } = useSWR(`${Api.baseUrl}${Api.admin.indicators.base}/${code}`);
  return { data, isValidating, error, mutate, revalidate };
};

export const useAdminSources = (params: RestQueryExtras): RequiredSwrResponse<Paged<IndicatorSource>, any> => {
  const { data, isValidating, error, mutate, revalidate } = useSWR(`${Api.baseUrl}${Api.admin.indicators.sources}${toPaginationQuery(params)}`);
  return { data, isValidating, error, mutate, revalidate };
};

export const useAdminSource = (code: string): RequiredSwrResponse<IndicatorSource, any> => {
  const { data, isValidating, error, mutate, revalidate } = useSWR(`${Api.baseUrl}${Api.admin.indicators.sources}/${code}`);
  return { data, isValidating, error, mutate, revalidate };
};

export const useAdminExternalDataSources = (): RequiredSwrResponse<string[], any> => {
  const { data, isValidating, error, mutate, revalidate } = useSWR(`${Api.baseUrl}${Api.admin.indicators.externalDataSources}`);
  return { data, isValidating, error, mutate, revalidate };
};

